<template>
  <div v-if="notification" class="w-auto h-auto bg-white fixed right-3 top-14 border-2 max-w-xl dark:bg-slate-900 shadow-md dark:shadow-md-gray-800 rounded-md py-5 px-6 z-50">
    <p v-if="messages.type == 'success'" class="text-slate-400 flex items-center">
      <span class="mr-3">
        <svg width="40px" height="40px" viewBox="0 0 400 400" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M341 67C148.339 290.671 183.5 343.046 131 205.023" stroke="#000000" stroke-opacity="0.9" stroke-width="16" stroke-linecap="round" />
          <path d="M126.678 74.6892C175.762 40.3656 223.672 30.3765 275.706 57.7602C415.664 131.409 354.622 382.384 180.329 356.983C85.4278 343.149 -9.51278 223.621 90.9151 117.034" stroke="#000000" stroke-opacity="0.9" stroke-width="16" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </span>

      {{ messages.message }}
    </p>
    <p v-else class="text-red-500 flex items-center">
      <span class="mr-3">
        <svg fill="#FF0000" height="40px" width="40px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 501.481 501.481" xml:space="preserve">
          <g>
            <g>
              <path
                d="M498.281,468.34L270.014,11.807c-4.267-7.467-10.667-11.733-19.2-11.733s-16,4.267-19.2,11.733L2.281,471.541
                                    			c-3.2,6.4-3.2,13.867,1.067,20.267c4.267,5.333,10.667,9.6,18.133,9.6h458.667c11.733,0,21.333-9.6,21.333-21.333
                                    			C501.48,475.807,500.414,471.541,498.281,468.34z M54.547,459.807L250.814,67.274l195.2,392.533H54.547z"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M250.814,182.474c-11.733,0-21.333,9.6-21.333,21.333v110.933c0,11.733,9.6,21.333,21.333,21.333
                                    			s20.267-9.6,21.333-21.333V203.807C272.147,192.074,262.547,182.474,250.814,182.474z"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M250.814,369.141c-11.733,0-21.333,9.6-21.333,21.333v7.467c0,11.733,9.6,21.333,21.333,21.333s20.267-9.6,21.333-21.333
                                    			v-7.467C272.147,378.741,262.547,369.141,250.814,369.141z"
              />
            </g>
          </g>
        </svg>
      </span>
      {{ messages.message }}
    </p>

    <div class="cookie-popup-actions text-right">
      <button @click="hideBanner" class="absolute border-none bg-none p-0 cursor-pointer font-semibold top-2 right-2"><i class="uil uil-times text-dark dark:text-slate-200 text-2xl"></i></button>
    </div>
  </div>
  <div v-if="chargement" id="loader" :style="{ height: scrollHeight + 'px' }" class="absolute w-full bgBlack z-50 flex flex-col items-center justify-center">
    <!-- <div class="loader ease-linear rounded-full border-4 border-t-4 border-gray-200 h-12 w-12 mb-4"></div> -->
    <div>
      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; background: none; display: block" width="200px" height="200px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
        <circle cx="75" cy="50" fill="#dcfff8" r="5">
          <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.9166666666666666s"></animate>
          <animate attributeName="fill" values="#dcfff8;#dcfff8;#00e2ff;#dcfff8;#dcfff8" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.9166666666666666s"></animate>
        </circle>
        <circle cx="71.65063509461098" cy="62.5" fill="#dcfff8" r="5">
          <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.8333333333333334s"></animate>
          <animate attributeName="fill" values="#dcfff8;#dcfff8;#00e2ff;#dcfff8;#dcfff8" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.8333333333333334s"></animate>
        </circle>
        <circle cx="62.5" cy="71.65063509461096" fill="#dcfff8" r="5">
          <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.75s"></animate>
          <animate attributeName="fill" values="#dcfff8;#dcfff8;#00e2ff;#dcfff8;#dcfff8" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.75s"></animate>
        </circle>
        <circle cx="50" cy="75" fill="#dcfff8" r="5">
          <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.6666666666666666s"></animate>
          <animate attributeName="fill" values="#dcfff8;#dcfff8;#00e2ff;#dcfff8;#dcfff8" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.6666666666666666s"></animate>
        </circle>
        <circle cx="37.50000000000001" cy="71.65063509461098" fill="#dcfff8" r="5">
          <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.5833333333333334s"></animate>
          <animate attributeName="fill" values="#dcfff8;#dcfff8;#00e2ff;#dcfff8;#dcfff8" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.5833333333333334s"></animate>
        </circle>
        <circle cx="28.34936490538903" cy="62.5" fill="#dcfff8" r="5">
          <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.5s"></animate>
          <animate attributeName="fill" values="#dcfff8;#dcfff8;#00e2ff;#dcfff8;#dcfff8" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.5s"></animate>
        </circle>
        <circle cx="25" cy="50" fill="#dcfff8" r="5">
          <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.4166666666666667s"></animate>
          <animate attributeName="fill" values="#dcfff8;#dcfff8;#00e2ff;#dcfff8;#dcfff8" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.4166666666666667s"></animate>
        </circle>
        <circle cx="28.34936490538903" cy="37.50000000000001" fill="#dcfff8" r="5">
          <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.3333333333333333s"></animate>
          <animate attributeName="fill" values="#dcfff8;#dcfff8;#00e2ff;#dcfff8;#dcfff8" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.3333333333333333s"></animate>
        </circle>
        <circle cx="37.499999999999986" cy="28.34936490538904" fill="#dcfff8" r="5">
          <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.25s"></animate>
          <animate attributeName="fill" values="#dcfff8;#dcfff8;#00e2ff;#dcfff8;#dcfff8" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.25s"></animate>
        </circle>
        <circle cx="49.99999999999999" cy="25" fill="#dcfff8" r="5">
          <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.16666666666666666s"></animate>
          <animate attributeName="fill" values="#dcfff8;#dcfff8;#00e2ff;#dcfff8;#dcfff8" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.16666666666666666s"></animate>
        </circle>
        <circle cx="62.5" cy="28.349364905389034" fill="#dcfff8" r="5">
          <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.08333333333333333s"></animate>
          <animate attributeName="fill" values="#dcfff8;#dcfff8;#00e2ff;#dcfff8;#dcfff8" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.08333333333333333s"></animate>
        </circle>
        <circle cx="71.65063509461096" cy="37.499999999999986" fill="#dcfff8" r="5">
          <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="0s"></animate>
          <animate attributeName="fill" values="#dcfff8;#dcfff8;#00e2ff;#dcfff8;#dcfff8" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="0s"></animate>
        </circle>
      </svg>
    </div>

    <h2 class="text-center text-white text-xl font-semibold">Chargement en cours...</h2>
    <p class="w-1/3 text-center text-white">Vérifier votre téléphone pour confirmer le payement.</p>
  </div>
  <div id="myDIV" class="container mt-24">
    <div class="rounded-md shadow dark:shadow-gray-800 bg-white dark:bg-slate-900">
      <div class="p-6 md:flex justify-between items-center border-b border-gray-100 dark:border-gray-700">
        <div class="mb-4 md:mb-0">
          <h5 class="text-2xl font-bold uppercase">Commande !!!</h5>
        </div>
        <div class="">
          <button class="btn bg-bsd-700 hover:bg-indigo-700 border-indigo-600 hover:border-indigo-700 text-white rounded-md mr-2">
            Plan sélectionné :
            <span class="font-bold text-lg">
              {{ pack.nom }}
              <!-- / {{ periodPlan }} {{ Monthy.month  }}-->
            </span>
          </button>
          <!-- <button
            class="btn bg-emerald-600 hover:bg-emerald-700 border-emerald-600 hover:border-emerald-700 text-white rounded-md mt-2 md:mt-0">Total
            Kit : <span class="font-bold text-lg"> {{ totalKit }} </span></button> -->
        </div>
      </div>

      <div class="p-6">
        <h5 class="text-2xl font-bold">Vous y êtes presque ! Complétez votre commande</h5>
        <!-- <p class="text-slate-400 mt-2">Your next monthly charge of $18 will be applied to your primary payment method on
        July 20, 2022.</p> -->
      </div>
    </div>

    <!-- choix du pack -->
    <div class="rounded-md shadow dark:shadow-gray-800 bg-white dark:bg-slate-900 mt-16">
      <div class="p-6 md:flex justify-between items-center border-b border-gray-100 dark:border-gray-700">
        <div class="mb-4 md:mb-0">
          <!-- <h5 class="text-xl md:text-3xl font-bold uppercase">1. Choix de Pack !!!</h5> -->
          <h5 class="text-xl md:text-3xl font-bold uppercase">1.Détail du pack !!!</h5>
        </div>
      </div>
      <div class="p-6">
        <div class="relative grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-[30px]">
          <pack-card-component :packSelected="packSelectionner" />
        </div>
      </div>
    </div>

    <!-- compte - création -->
    <div class="rounded-md shadow dark:shadow-gray-800 bg-white dark:bg-slate-900 mt-16">
      <div class="p-6 md:flex justify-between items-center border-b border-gray-100 dark:border-gray-700">
        <div class="mb-4 md:mb-0">
          <h5 class="text-xl md:text-3xl font-bold uppercase">2.informations personnels</h5>
        </div>
      </div>
      <div class="p-6">
        <div class="relative grid grid-cols-1 xl:grid-cols-2 _gap-[30px]">
          <p>Vous avez déjà un compte ? <button class="btn btn-link text-indigo-600 after:bg-indigo-600 duration-500 ease-in-out">S'identifier</button></p>
          <div class="flex flex-col formulaire space-x-2 w-full">
            <div class="w-full md:w-1/2 mr-2 space-y-2">
              <div class="form-icon relative mt-2">
                <label for="nom" class="mb-2">Nom</label>
                <div class="form-icon relative mt-2">
                  <i class="uil uil-postcard w-4 h-4 absolute top-2 left-4"></i>
                  <input name="nom" id="nom" v-model="formulaire.nom" type="text" class="form-input pl-11" placeholder="Nom :" />
                </div>
              </div>

              <div class="form-icon relative mt-2">
                <label for="nom" class="mb-2">Email</label>
                <div class="form-icon relative mt-2">
                  <i class="uil uil-envelope w-4 h-4 absolute top-2 left-4"></i>
                  <input name="email" id="email" v-model="formulaire.email" type="email" class="form-input pl-11" placeholder="Email :" />
                </div>
              </div>

              <div class="form-icon relative mt-2">
                <label for="nom" class="mb-2">Nom de votre entreprise</label>
                <div class="form-icon relative mt-2">
                  <i class="uil uil-postcard w-4 h-4 absolute top-2 left-4"></i>
                  <input name="entrepriseName" id="entrepriseName" v-model="formulaire.entrepriseNom" type="text" class="form-input pl-11" placeholder="Nom de votre entreprise :" />
                </div>
              </div>

              <div class="form-icon relative mt-2">
                <label for="nom" class="mb-2">Pays</label>
                <div class="form-icon relative mt-2">
                  <svg class="w-4 h-4 absolute top-2 left-4" fill="#000000" width="800px" height="800px" viewBox="0 0 512 512" version="1.1" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                    <g id="_x36_40_x2C__Country_x2C__flag_x2C__usa">
                      <g>
                        <g>
                          <g>
                            <g>
                              <g>
                                <path d="M89.053,388.314c-4.773,0-8.998-3.43-9.841-8.293c-0.944-5.441,2.702-10.618,8.144-11.562        c30.574-5.304,40.438-26.399,52.926-53.106c14.229-30.431,31.938-68.302,86.846-87.881c5.203-1.855,10.923,0.859,12.777,6.061        c1.855,5.202-0.858,10.923-6.061,12.777c-47.044,16.775-61.483,47.653-75.446,77.515        c-13.162,28.147-26.771,57.253-67.625,64.34C90.195,388.266,89.62,388.314,89.053,388.314z" />
                              </g>

                              <g>
                                <path d="M67.741,367.002c-4.773,0-8.998-3.429-9.841-8.293c-0.944-5.441,2.702-10.618,8.144-11.562        c30.573-5.304,40.437-26.398,52.925-53.105c14.229-30.431,31.938-68.303,86.847-87.881c5.202-1.857,10.923,0.858,12.777,6.061        c1.855,5.202-0.858,10.923-6.061,12.777c-47.044,16.775-61.483,47.653-75.446,77.514        c-13.162,28.147-26.771,57.254-67.625,64.34C68.884,366.953,68.308,367.002,67.741,367.002z" />
                              </g>

                              <g>
                                <path d="M46.527,345.789c-4.773,0-8.998-3.43-9.841-8.293c-0.944-5.441,2.702-10.618,8.144-11.562        c30.574-5.304,40.438-26.399,52.926-53.107c0.878-1.879,1.764-3.771,2.663-5.674c2.36-4.993,8.32-7.129,13.315-4.766        c4.993,2.36,7.126,8.321,4.766,13.314c-0.887,1.877-1.76,3.743-2.626,5.597c-13.162,28.147-26.772,57.254-67.625,64.341        C47.67,345.74,47.095,345.789,46.527,345.789z" />
                              </g>

                              <g>
                                <path d="M111.041,410.289c-2.629,0-5.179-1.037-7.07-2.929l-85.715-85.715c-2.641-2.641-3.59-6.532-2.462-10.092        c1.128-3.56,4.145-6.194,7.824-6.832c30.573-5.304,40.438-26.399,52.926-53.106c14.229-30.431,31.938-68.302,86.846-87.881        c3.635-1.297,7.698-0.384,10.43,2.348l86.622,86.622c2.425,2.425,3.438,5.923,2.685,9.268s-3.168,6.071-6.397,7.223        c-47.063,16.782-61.744,47.424-75.94,77.058c-13.381,27.93-27.217,56.81-68.038,63.891        C112.181,410.24,111.608,410.289,111.041,410.289z M44.421,319.527l69.871,69.87c26.833-6.645,36.454-26.73,48.459-51.788        c13.112-27.368,29.135-60.809,72.938-81.374l-71.438-71.437c-42.423,17.186-56.225,46.703-69.591,75.289        C83.571,283.8,72.167,308.192,44.421,319.527z" />
                              </g>

                              <g>
                                <path d="M367.369,383.774c-2.56,0-5.118-0.977-7.071-2.929L232.156,252.704c-3.905-3.905-3.905-10.237,0-14.143        s10.237-3.905,14.143,0L374.44,366.703c3.905,3.905,3.905,10.237,0,14.143C372.487,382.798,369.929,383.774,367.369,383.774z" />
                              </g>

                              <g>
                                <path d="M130.864,299.741c-2.559,0-5.118-0.977-7.071-2.929l-40.408-40.407c-3.905-3.905-3.906-10.237,0-14.142        s10.237-3.906,14.142,0l40.408,40.407c3.905,3.905,3.906,10.237,0,14.143C135.982,298.765,133.423,299.741,130.864,299.741z" />
                              </g>
                            </g>

                            <g>
                              <g>
                                <path d="M450.209,224.289c-17.424,0-34.063-6.037-50.395-11.961c-30.989-11.242-63.031-22.867-108.16-1.462        c-4.991,2.367-10.954,0.24-13.32-4.75c-2.367-4.99-0.24-10.954,4.75-13.321c52.671-24.982,91.974-10.725,123.551,0.732        c27.715,10.054,49.606,17.996,74.976,0.127c4.518-3.181,10.755-2.097,13.935,2.417c3.18,4.515,2.098,10.754-2.417,13.934        C478.181,220.533,463.951,224.289,450.209,224.289z" />
                              </g>

                              <g>
                                <path d="M450.209,194.149c-17.424,0-34.063-6.037-50.395-11.961c-30.988-11.243-63.034-22.867-108.16-1.462        c-4.991,2.367-10.953,0.24-13.32-4.75c-2.367-4.99-0.24-10.954,4.75-13.321c52.673-24.983,91.973-10.724,123.551,0.732        c27.717,10.054,49.609,17.995,74.976,0.127c4.518-3.18,10.755-2.098,13.935,2.417s2.098,10.754-2.417,13.934        C478.181,190.393,463.951,194.149,450.209,194.149z" />
                              </g>

                              <g>
                                <path d="M450.21,164.148c-17.425,0-34.064-6.037-50.396-11.961c-1.924-0.698-3.861-1.401-5.816-2.101        c-5.2-1.861-7.906-7.585-6.045-12.785s7.59-7.904,12.785-6.045c1.981,0.709,3.946,1.422,5.896,2.129        c27.715,10.055,49.606,17.996,74.976,0.128c4.518-3.18,10.755-2.098,13.935,2.417s2.098,10.753-2.417,13.934        C478.182,160.393,463.951,164.148,450.21,164.148z" />
                              </g>

                              <g>
                                <path
                                  d="M449.628,255.559c-17.014,0-32.934-5.606-49.788-11.542c-18.017-6.345-36.646-12.906-58.003-12.906        c-16.578,0-32.993,3.963-50.183,12.116c-3.099,1.47-6.734,1.249-9.631-0.583c-2.897-1.833-4.654-5.023-4.654-8.452V111.69        c0-3.863,2.225-7.38,5.715-9.035c19.712-9.35,38.718-13.895,58.104-13.895c25.132,0,46.551,7.771,65.448,14.626        c15.316,5.557,29.783,10.805,43.479,10.805c11.145,0,21.152-3.393,31.495-10.678c3.053-2.149,7.049-2.42,10.364-0.701        c3.314,1.72,5.395,5.143,5.395,8.876v121.219c0,3.253-1.582,6.303-4.241,8.176C479.3,250.824,465.071,255.559,449.628,255.559        z M341.837,211.111c24.775,0,45.958,7.46,64.646,14.042c15.196,5.352,29.549,10.406,43.145,10.406        c9.801,0,18.727-2.572,27.741-8.043v-98.814c-8.755,3.682-17.775,5.491-27.254,5.491c-17.211,0-33.283-5.831-50.3-12.004        c-18.195-6.601-37.012-13.427-58.627-13.427c-14.512,0-28.903,3.081-43.819,9.398v101.012        C312.287,213.759,326.95,211.111,341.837,211.111z"
                                />
                              </g>

                              <g>
                                <path d="M287.369,423.152c-5.522,0-10-4.478-10-10V231.934c0-5.523,4.478-10,10-10s10,4.477,10,10v181.219        C297.369,418.675,292.892,423.152,287.369,423.152z" />
                              </g>

                              <g>
                                <path d="M395.184,178.757c-5.522,0-10-4.477-10-10v-57.146c0-5.523,4.478-10,10-10s10,4.477,10,10v57.146        C405.184,174.28,400.706,178.757,395.184,178.757z" />
                              </g>
                            </g>
                          </g>
                        </g>
                      </g>
                    </g>

                    <g id="Layer_1" />
                  </svg>
                  <input name="pays" id="pays" v-model="formulaire.pays" type="text" class="form-input pl-11" placeholder="Pays :" />
                </div>
              </div>

              <div class="form-icon relative mt-2">
                <label for="nom" class="mb-2">Boite postale</label>
                <div class="form-icon relative mt-2">
                  <svg class="w-4 h-4 absolute top-2 left-4" fill="#000000" height="800px" width="800px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 465 465" xml:space="preserve">
                    <g>
                      <path
                        d="M337.5,110h-56.464c-4.142,0-7.5,3.357-7.5,7.5s3.358,7.5,7.5,7.5H337.5c43.541,0,78.964,35.423,78.964,78.964v137.021
              		h-195V203.964c0-33.077-17.182-62.215-43.088-78.964h42.659c4.142,0,7.5-3.357,7.5-7.5s-3.358-7.5-7.5-7.5H127.5
              		c-51.812,0-93.964,42.152-93.964,93.964v144.521c0,4.143,3.358,7.5,7.5,7.5h165.429V457.5c0,4.143,3.358,7.5,7.5,7.5
              		s7.5-3.357,7.5-7.5V355.985h22.071V457.5c0,4.143,3.358,7.5,7.5,7.5s7.5-3.357,7.5-7.5V355.985h165.429c4.142,0,7.5-3.357,7.5-7.5
              		V203.964C431.464,152.152,389.312,110,337.5,110z M48.536,203.964C48.536,160.423,83.959,125,127.5,125
              		s78.964,35.423,78.964,78.964v137.021H48.536V203.964z"
                      />
                      <path
                        d="M251.036,283.725c4.142,0,7.5-3.357,7.5-7.5V73h67.695c9.098,0,16.5-7.402,16.5-16.5v-40c0-9.098-7.402-16.5-16.5-16.5
              		h-75.195c-4.142,0-7.5,3.357-7.5,7.5v268.725C243.536,280.367,246.894,283.725,251.036,283.725z M327.73,16.5v40
              		c0,0.827-0.673,1.5-1.5,1.5h-67.695V15h67.695C327.058,15,327.73,15.673,327.73,16.5z"
                      />
                      <path
                        d="M127.5,160c-4.142,0-7.5,3.357-7.5,7.5v23c0,4.143,3.358,7.5,7.5,7.5s7.5-3.357,7.5-7.5v-23
              		C135,163.357,131.642,160,127.5,160z"
                      />
                    </g>
                  </svg>
                  <input name="nombre" id="nombre" v-model="formulaire.boitePostale" type="text" class="form-input pl-11" placeholder="boite postale :" />
                </div>
              </div>
            </div>

            <div class="w-full md:w-1/2 space-y-2">
              <div class="form-icon relative mt-2">
                <label for="nom" class="mb-2">Prénom</label>
                <div class="form-icon relative mt-2">
                  <i class="uil uil-postcard w-4 h-4 absolute top-2 left-4"></i>
                  <input name="prenom" id="prenom" v-model="formulaire.prenoms" type="text" class="form-input pl-11" placeholder="Prénom :" />
                </div>
              </div>

              <div class="form-icon relative mt-2">
                <label for="nom" class="mb-2">Conctact de votre Entreprise</label>
                <div class="form-icon relative mt-2">
                  <i class="uil uil-calling w-4 h-4 absolute top-2 left-4"></i>
                  <input name="Conctact" id="Conctact" v-model="formulaire.entrepriseContact" type="number" class="form-input pl-11" placeholder="Conctact de votre Entreprise :" />
                </div>
              </div>

              <div class="form-icon relative mt-2">
                <label for="nom" class="mb-2">Domaine</label>
                <div class="form-icon relative mt-2">
                  <i class="uil uil-envelope w-4 h-4 absolute top-2 left-4"></i>
                  <input name="domaine" id="domaine" v-model="formulaire.domaine" type="text" class="form-input pl-11" placeholder="Domaine :" />
                </div>
              </div>
              <div class="form-icon relative mt-2">
                <label for="nom" class="mb-2">Arrondissement</label>
                <div class="form-icon relative mt-2">
                  <i class="uil uil-envelope w-4 h-4 absolute top-2 left-4"></i>
                  <input name="Arrondissement" id="Arrondissement" v-model="formulaire.arrondissement" type="text" class="form-input pl-11" placeholder="Arrondissement :" />
                </div>
              </div>
              <div class="form-icon relative mt-2">
                <label for="nom" class="mb-2">Ville</label>
                <div class="form-icon relative mt-2">
                  <svg class="w-4 h-4 absolute top-2 left-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512">
                    <!--! Font Awesome Pro 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
                    <path
                      d="M480 48c0-26.5-21.5-48-48-48H336c-26.5 0-48 21.5-48 48V96H224V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V96H112V24c0-13.3-10.7-24-24-24S64 10.7 64 24V96H48C21.5 96 0 117.5 0 144v96V464c0 26.5 21.5 48 48 48H304h32 96H592c26.5 0 48-21.5 48-48V240c0-26.5-21.5-48-48-48H480V48zm96 320v32c0 8.8-7.2 16-16 16H528c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16zM240 416H208c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16zM128 400c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32zM560 256c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H528c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h32zM256 176v32c0 8.8-7.2 16-16 16H208c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16zM112 160c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h32zM256 304c0 8.8-7.2 16-16 16H208c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32zM112 320H80c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16zm304-48v32c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16zM400 64c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16h32zm16 112v32c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16z"
                    />
                  </svg>
                  <input name="Ville" id="Ville" v-model="formulaire.ville" type="text" class="form-input pl-11" placeholder="Ville :" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- paiement -->
    <div class="rounded-md shadow dark:shadow-gray-800 bg-white dark:bg-slate-900 mt-16">
      <div class="p-6 md:flex justify-between items-center border-b border-gray-100 dark:border-gray-700">
        <div class="mb-4 md:mb-0">
          <h5 class="text-xl md:text-3xl font-bold uppercase">3. Paiement</h5>
          <p class="text-slate-400 mt-2">Sélectionnez le moyen de paiement qui vous convient et procéder à la validation de votre commande.</p>
        </div>
      </div>
      <div class="p-6">
        <div class="relative flex flex-col lg:flex-row gap-[30px]">
          <div class="w-1/4 _px-6">
            <ul>
              <!-- <li class="flex justify-between items-center py-6">
              <div class="flex items-center">
                <img src="../assets/images/payments/visa.png" class="rounded shadow dark:shadow-gray-800 w-12" alt="">

                <div class="ml-3">
                  <p class="font-semibold">VISA</p>
                  <p class="text-slate-400 text-sm">Bénin / Togo/ Côte d’ivoire</p>
                </div>
              </div>
              <button @click="selectedPayment" :class="{ '_text-selected': selectedText, 'text-normal': !selectedText, }"
                type="checkbox"><i :class="{ '_uil-check-circle': isActive, 'uil-circle': !isActive, }"
                  class="uil text-indigo-600 text-2xl font-bold ml-4"></i></button>
            </li> -->

              <li class="flex justify-between items-center py-6 border-t border-gray-100 dark:border-gray-700">
                <div class="flex items-center">
                  <img src="../assets/images/payments/mtnmomolatest.svg" class="rounded shadow dark:shadow-gray-800 w-12" alt="" />

                  <div class="ml-3">
                    <p class="font-semibold">MTN MOBILE MONEY - MOOV MONEY</p>
                    <p class="text-slate-400 text-sm">Bénin / Togo/ Côte d’ivoire</p>
                  </div>
                </div>
                <button @click="selectedPayment" :class="{ 'text-selected': selectedText }" type="checkbox"><i :class="{ 'uil-check-circle': isActive }" class="uil text-indigo-600 text-2xl font-bold mr-2"></i></button>
              </li>
            </ul>
          </div>
          <div class="w-full">
            <div class="relative overflow-x-auto shadow dark:shadow-gray-800 rounded-md mt-6">
              <table class="w-full text-left text-slate-500 dark:text-slate-400">
                <thead class="text-sm uppercase bg-slate-50 dark:bg-slate-800">
                  <tr>
                    <th scope="col" class="px-6 py-3 w-16">No.</th>
                    <th scope="col" class="px-6 py-3">Désignation</th>

                    <th scope="col" class="px-6 py-3 w-20">Total</th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="bg-white dark:bg-slate-900">
                    <td class="px-6 py-4 text-center">1</td>
                    <th scope="row" class="px-6 py-4 font-medium text-gray-900 dark:text-white whitespace-nowrap">
                      {{ pack.nom }}
                    </th>

                    <td class="px-6 py-4 whitespace-nowrap">{{ pack.montant }} XOF</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- information carte bancaire -->
            <div class="p-6 rounded-md shadow dark:shadow-gray-800 bg-white dark:bg-slate-900 mt-4">
              <h5 class="text-lg font-semibold mb-4">Numéro de paiement :</h5>
              <form @submit.prevent="saveInfo()">
                <div class="grid lg:grid-cols-1 grid-cols-1 gap-5">
                  <div>
                    <div class="form-icon relative mt-2">
                      <i class="uil uil-phone -4 h-4 absolute top-2 left-4"></i>
                      <input name="name" id="occupation" v-model="formulaire.contact" type="number" class="form-input pl-12" placeholder="+229 000 000 00" />
                    </div>
                  </div>
                </div>
                <!--end grid-->
                <button type="submit" id="submitNumber" name="Payment Number" class="btn bg-bsd-700 hover:bg-indigo-700 border-indigo-600 hover:border-indigo-700 text-white rounded-md mt-5">
                  <span class="text-sm font-semibold uppercase" v-if="!chargement"> Éffectuez le paiement</span>
                  <span v-else class="flex justify-center items-center space-x-2">
                    <span class="px-4 font-semibold"> chargement ... </span>
                    <svg xmlns="http://www.w3.org/2000/svg" class="w-8 h-8 text-center animate-spin" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                    </svg>
                  </span>
                </button>
              </form>
              <!--end form-->
            </div>

            <!-- information carte bancaire -->

            <!-- <div class="p-6 rounded-md shadow dark:shadow-gray-800 bg-white dark:bg-slate-900 mt-4">
            <h5 class="text-lg font-semibold mb-4">Information de la carte :</h5>
            <form>
              <div class="grid lg:grid-cols-2 grid-cols-1 gap-5">
                <div>
                  <div class="form-icon relative mt-2">
                    <i class="uil uil-card-atm -4 h-4 absolute top-2 left-4"></i>
                    <input type="text" class="form-input pl-12" placeholder="Nom complet sur la carte" id="firstname"
                      name="name" required="">
                  </div>
                </div>
                <div>
                  <div class="form-icon relative mt-2">
                    <i class="uil uil-card-atm -4 h-4 absolute top-2 left-4"></i>
                    <input type="text" class="form-input pl-12" placeholder="0000 0000 0000 0000" id="lastname"
                      name="name" required="">
                  </div>
                </div>
                <div>
                  <div class="form-icon relative mt-2">
                    <i class="uil uil-card-atm -4 h-4 absolute top-2 left-4"></i>
                    <input type="email" class="form-input pl-12" placeholder="MM/YY" name="email" required="">
                  </div>
                </div>
                <div>
                  <div class="form-icon relative mt-2">
                    <i class="uil uil-card-atm -4 h-4 absolute top-2 left-4"></i>
                    <input name="name" id="occupation" type="text" class="form-input pl-12" placeholder="CVC code">
                  </div>
                </div>
              </div> 

            


              <input type="submit" id="submitCart" name="send"
                class="btn bg-indigo-600 hover:bg-indigo-700 border-indigo-600 hover:border-indigo-700 text-white rounded-md mt-5"
                value="Éffectuez le paiement">
            </form>
            
            
          </div>  -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PackCardComponent from "./PackCardComponent.vue";
import PackService from "@/services/modules/pack.service";
import SouscriptionService from "@/services/modules/souscription.service";

export default {
  components: { PackCardComponent },
  name: "",
  data() {
    return {
      confirmPassword: "",
      showError: false,
      selectedPlan: "QR Link",
      periodPlan: 7,
      Monthy: {
        month: "mois",
        year: "année",
      },
      totalKit: 3,
      isActive: true,
      selectedText: true,
      packId: "",
      packSelectionner: [],
      pack: {},
      contact: Number,
      scrollHeight: "",
      chargement: false,
      notification: false,

      formulaire: {
        email: "",
        nom: "",
        prenoms: "",
        entrepriseNom: "",
        entrepriseContact: "",
        pays: "",
        ville: "",
        arrondissement: "",
        domaine: "",
        packId: "",
        contact: "",
      },
      afficherMp: true,
      afficherMp2: true,
      type: "password",
      type2: "password",

      idPayement: "",
      infoPayement: {
        nom: "",
        nombre: "",
        montant: "",
        description: "",
        id: "",
      },
      chargement2: false,
      messages: {
        type: "",
        message: "",
      },
    };
  },
  beforeMount() {
    this.packId = this.$route.params.id;
    this.getPackSelected();
  },
  mounted() {},

  methods: {
    selectedPayment() {
      this.isActive = !this.isActive;
      this.selectedText = !this.selectedText;
    },

    showPassword() {
      this.afficherMp = !this.afficherMp;

      if (this.afficherMp) {
        this.type = "password";
      } else {
        this.type = "text";
      }
    },
    showPassword2() {
      this.afficherMp2 = !this.afficherMp2;

      if (this.afficherMp2) {
        this.type2 = "password";
      } else {
        this.type2 = "text";
      }
    },

    getPackSelected() {
      PackService.getOnePack(this.packId)
        .then((response) => {
          let selected = response.data.data;

          this.packSelectionner = selected;

          this.pack = selected;
        })
        .catch((e) => {});
    },

    closeNotification() {
      this.notification = false;
    },

    successNotificationToggles(statut, message) {
      this.messages.type = statut;
      this.messages.message = message;

      this.notification = true;

      setTimeout(() => {
        this.notification = false;
      }, 3000);
    },

    saveInfo() {
      this.chargement = false;

     

      this.scrollHeight = document.getElementById("myDIV").scrollHeight;

      this.formulaire.packId = this.packId;

      if (this.chargement == false) {
        this.chargement = true;

        window.scrollTo({
          top: this.scrollHeight / 2.5,
          behavior: "smooth",
        });
        document.getElementById("myDIV").style.overflow = "hidden";

        SouscriptionService.create(this.formulaire)
          .then((reponse) => {
            this.chargement = false;
            document.getElementById("myDIV").style.overflow = "scroll";
            this.successNotificationToggles(reponse.data.statut, reponse.data.message);

            window.location.href = "https://dashboard.mybsd.shop/";
          })
          .catch((e) => {
            this.chargement = false;
            document.getElementById("myDIV").style.overflow = "scroll";

            this.successNotificationToggles(e.response.data.statut, e.response.data.message);
          });
      }
    },

    payPack() {
      if (this.chargement2 == false) {
        this.chargement2 = true;

        SouscriptionService.pay(this.infoPayement.id)
          .then((response) => {
            this.payModalPreview = false;
            this.successNotificationToggles(response.data.statut, response.data.message);
          })
          .catch((e) => {
            this.payModalPreview = false;

            this.successNotificationToggles(e.statut, e.message);
          });
      }
    },
  },
};
</script>

<style scoped>
/* .persoBg {
  background-color: rgb(64, 52, 52);
  color: black;
} */

.custom_button {
  background: red;
  border-radius: 6px;
  width: 100%;
  color: white;
  padding: 10px;
  font-weight: bold;
  font-size: 14px;
}

/* Chrome */
input::-webkit-inner-spin-button,
input::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Opéra*/
input::-o-inner-spin-button,
input::-o-outer-spin-button {
  -o-appearance: none;
  margin: 0;
}

.bgBlack {
  background: rgba(0, 0, 0, 0.749);
}

.loader {
  border-top-color: #3498db;
  -webkit-animation: spinner 1.5s linear infinite;
  animation: spinner 1.5s linear infinite;
}

@-webkit-keyframes spinner {
  0% {
    -webkit-transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spinner {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}

@media screen and (min-width: 768px) {
  .formulaire {
    flex-direction: row !important;
  }
}
</style>
